import { TableExtractPtBr } from "./table-extract-pt-br";

export const TABLE_EXTRACT_FR_FR: TableExtractPtBr = {
	consolidated: {
		title: "Consolidé de Compétence",
		totalTitle: "Total de lancement dans la compétence de {{period}}",
		tooltip: "Qu'est-ce que le résumé de compétence ?",
		tooltipDescription:
			"Opérations regroupées par la date à laquelle l'opération ou l'événement " +
			"économique s'est réellement produit.",
	},
	cashFlow: {
		title: "Mouvements de la période",
		totalTitle: "Solde final de la période",
		tooltip: "Qu'est-ce que le résumé des mouvements ?",
		tooltipDescription:
			"Opérations de mouvements effectuées durant la période sélectionnée.",
	},
	tpv: {
		title: "Créances de la Période",
		totalTitle: "Total de la Période",
		tooltip: "Que sont les Créances de la Période ?",
		tooltipDescription:
			"Valeur brute des TPV regroupés de la période consultée, représentant les valeurs à recevoir des transactions traitées.",
	},
	total: "Total",
	name: "Description",
	value: "Valeur",
	grossValue: "Valeur Brute",
	netValue: "Valeur Nette",
	tax: "Taxe",
	base: "Base",
	feePercentage: "Tarif",
	from: "De",
	to: "à",
	group: "Groupe",
	excel: {
		title:
			"Rapport Consolidé par Période de Mouvements et Consolidation de Compétence  {{startDate}} à {{endDate}}",
		fileName: "rapport_consolidé_mouvements_{{startDate}}_à_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Mouvements de la période",
	competenceConsolidated: "Consolidation de Compétence",
	notLiquidatedTransactions: "Transactions non liquidées de la période",
	anticipatedValue: "Valeur Anticipée",
	obs: "Observation",
	seeTransactions: "Voir les Transactions",
	dateType: {
		competence: "Date de Compétence",
		liquidation: "Date de Liquidation",
	},
	dateTypeLabel: "Filtrer par",
	competence: "Compétence",
	liquidation: "Liquidation",
	apply: "Appliquer",
	initialBalance: "Solde Initial",
	finalBalance: "Solde Final",
};
